module.exports = __webpack_public_path__ + "static/media/payments.ccc999e3.svg";